export default async function ({ store, redirect, route }) {
  store.commit("payin/SET_CURRENT_ORIGIN", route.query.origin)
  store.commit("payin/packs/SELECT_BY_ID", 0)
  if (route.query.amount)
    store.commit("payin/SET_UNITARY_PACK_COST", route.query.amount)
  if (route.query.pack) {
    await store.dispatch("payin/packs/FETCH")
    store.commit("payin/packs/SELECT_BY_ID", Number(route.query.pack))

    if (!store.getters["payin/packs/SELECTED_PACK_OBJ"])
      return redirect("/band/shop/")
  }
  if (!store.getters["payin/PURCHASE_TYPE"]) return redirect("/")
  else if (store.getters["payin/PURCHASE_TYPE"] === "sendtrack") {
    try {
      await store.dispatch("draft/GET_CURRENT", {
        clean_hidden_influencers: true,
      })
      if (store.state.draft.id === 0) return redirect("/")
      if (!store.getters["draft/pricing/NEED_PURCHASE"])
        return redirect(`/draft/${store.state.draft.id}/recap/`)
    } catch (error) {
      return redirect("/")
    }
  }
}
